import axios from "axios";
import {
  baseUrl
} from "../../../../api/common";

export const GetUserMemberApplicationData = async () => {
  try {
    const res = await axios.get(`${baseUrl}/api/get_application`);
    console.log(res);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const InsertUserDataOTP = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/send_otp`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertUserDataOTP:", err);
    if (err.response) {      
      throw new Error(err.response.data.message || "A network error occurred, or the server is temporarily busy. Please try again later");
    } else if (err.request) {
      console.error("No response received:", err.request);
      throw new Error("No response received from the server");
    } else {
      console.error("Request setup error:", err.message);
      throw new Error("Request setup error");
    }
  }
};
export const VerifyUserDataOTP = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/otp_verify`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertUserDataOTP:", err);
    if (err.response) {      
      throw new Error(err.response.data.message || "A network error occurred, or the server is temporarily busy. Please try again later");
    } else if (err.request) {
      console.error("No response received:", err.request);
      throw new Error("No response received from the server");
    } else {
      console.error("Request setup error:", err.message);
      throw new Error("Request setup error");
    }
  }
};
//
export const ResendUserDataOTP = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/resend_otp`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertUserDataOTP:", err);
    if (err.response) {      
      throw new Error(err.response.data.message || "A network error occurred, or the server is temporarily busy. Please try again later");
    } else if (err.request) {
      console.error("No response received:", err.request);
      throw new Error("No response received from the server");
    } else {
      console.error("Request setup error:", err.message);
      throw new Error("Request setup error");
    }
  }
};
///
export const GetMemberInfo = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/member_info`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertUserDataOTP:", err);
    if (err.response) {      
      throw new Error(err.response.data.message || "A network error occurred, or the server is temporarily busy. Please try again later");
    } else if (err.request) {
      console.error("No response received:", err.request);
      throw new Error("No response received from the server");
    } else {
      console.error("Request setup error:", err.message);
      throw new Error("Request setup error");
    }
  }
};
export const InsertMembersPersonalOld = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/member_two`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token")   
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertUserDataOTP:", err);
    if (err.response) {      
      throw new Error(err.response.data.message || "A network error occurred, or the server is temporarily busy. Please try again later");
    } else if (err.request) {
      console.error("No response received:", err.request);
      throw new Error("No response received from the server");
    } else {
      console.error("Request setup error:", err.message);
      throw new Error("Request setup error");
    }
  }
};
export const InsertMembersPersonal = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/member_two`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    return res.data;
  } catch (err) {
    console.error("Error in InsertMembersPersonal:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};
export const InsertMembersEducational = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/member_three`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertMembersEducational:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};
//check_application_status
export const CheckUserDataUserDataApplication = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/check_application_status`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in CheckUserDataUserDataApplication:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};
//delete_old_member_application
export const DeleteOldMemberApplication = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/delete_old_member_application`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  }  catch (err) {
    console.error("Error in DeleteOldMemberApplication:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};

//----22-02 Bharathi---------

export const InsertMembersPaymentDetails = async (data) => {
  console.log(
    `Payment Successful! Request Data:`,
    data
  );
  try {
    const res = await axios.post(`${baseUrl}/api/final_step`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Source": "web",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in InsertMembersPaymentDetails:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};


// ------24-02 Bharathi------

export const GetMemberActivity = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/get_member_activity`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  }  catch (err) {
    console.error("Error in GetMemberActivity:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};export const GetInvoiceData = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/invoice_data`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  } catch (err) {
    console.error("Error in GetInvoiceData:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};

export const GetMemberPaymentInfo = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/api/application_data`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("access_token"),
      },
    });

    console.log(res.data);
    return res.data;
  }  catch (err) {
    console.error("Error in GetMemberPaymentInfo:", err);

    let message = "A network error occurred. Please try again later.";

    if (err.response) {
      // Server returned error (400, 500, etc.)
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `Server error (${err.response.status})`;
    } else if (err.request) {
      // Request was made but no response
      message = "No response from server. Please check your internet connection.";
    } else {
      // Something else went wrong
      message = err.message || "Request failed";
    }

    throw new Error(message);
  }
};
